import manualFirst from 'src/assets/images/user-mobile/parking/manual-first.png';
import manualSecond from 'src/assets/images/user-mobile/parking/manual-second.png';
import manualThird from 'src/assets/images/user-mobile/parking/manual-third.png';

import { styled } from 'styled-components';
import { useState } from 'react';
import TopFixedBarParking from '../TopFixedBarAdmin';
import AdminFooter from '../AdminFooter';

export default function ManualComponent() {
  const [selected, setSelected] = useState<'first' | 'second' | 'third'>(
    'first',
  );

  return (
    <>
      <TopFixedBarParking />
      <PageContainer>
        <ManualContainer>
          <TitleContainer>
            <TitleArea>
              <p>주차장 관리 페이지</p>사용법 확인
            </TitleArea>
            <ButtonGroup>
              <ManualButton
                $isSelected={selected === 'first'}
                onClick={() => setSelected('first')}
              >
                주차/교통 공지 추가 사용법 확인
              </ManualButton>
              <ManualButton
                $isSelected={selected === 'second'}
                onClick={() => setSelected('second')}
              >
                주차장 혼잡도 관리 사용법 확인
              </ManualButton>
              <ManualButton
                $isSelected={selected === 'third'}
                onClick={() => setSelected('third')}
              >
                주차장 위치 확인
              </ManualButton>
            </ButtonGroup>
          </TitleContainer>
          {selected === 'first' && (
            <ManualImage
              src={manualFirst}
              alt="주차/교통 공지 추가 사용법 확인"
            />
          )}
          {selected === 'second' && (
            <ManualImage
              src={manualSecond}
              alt="주차장 혼잡도 관리 사용법 확인"
            />
          )}
          {selected === 'third' && (
            <ManualImage src={manualThird} alt="주차장 위치 확인" />
          )}
          <AdminFooter />
        </ManualContainer>
      </PageContainer>
    </>
  );
}

const PageContainer = styled.div`
  @media (min-width: 640px) {
    width: 640px;
    margin: 0 auto;
    background: #fff;
  }
`;

const ManualContainer = styled.div`
  background: #fff;
  margin-top: 52px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f4f3f4;
`;

const TitleArea = styled.div`
  text-align: center;
  color: #111;
  color: #111;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 150% */
  letter-spacing: -0.5px;

  padding: 24px 0 16px 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 300px;
  margin-bottom: 32px;
`;

const ManualButton = styled.button<{ $isSelected: boolean }>`
  width: 240px;
  padding: 12px 20px;

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.4px;

  background: ${({ $isSelected }) => ($isSelected ? '#f64827' : '#FFF')};
  color: ${({ $isSelected }) => ($isSelected ? '#fff' : '#707070')};
  border-radius: 16px;
  border: none;
  cursor: pointer;
`;

const ManualImage = styled.img`
  width: 100%;
  margin-top: 32px;
`;
